import logos from "../assets/logos/companies";

export const logoMarquee = [
  { imgUrl: logos["treasureTrove"], subText: "" },
  { imgUrl: logos["10ALabs"], subText: "" },
  { imgUrl: logos["vegaClaims"], subText: "" },
  { imgUrl: logos["dimensional"], subText: "" },
  { imgUrl: logos["prosights"], subText: "" },
  { imgUrl: logos["nurl"], subText: "" },
  { imgUrl: logos["tabflows"], subText: "" },
  { imgUrl: logos["turnout"], subText: "" },
  { imgUrl: logos["hedral"], subText: "" },
  { imgUrl: logos["spacial"], subText: "" },
  { imgUrl: logos["copia"], subText: "" },
  { imgUrl: logos["kai"], subText: "" },
  { imgUrl: logos["electronx"], subText: "" },
  { imgUrl: logos["engageli"], subText: "" },
  { imgUrl: logos["atlasInvest"], subText: "" },
  { imgUrl: logos["tulu"], subText: "" },
  { imgUrl: logos["spade"], subText: "" },
  { imgUrl: logos["rhino"], subText: "" },
  { imgUrl: logos["reserv"], subText: "" },
  { imgUrl: logos["insitro"], subText: "" },
  { imgUrl: logos["novaCredit"], subText: "" },
  { imgUrl: logos["nirvana"], subText: "" },
  { imgUrl: logos["futureSecureAi"], subText: "" },
  { imgUrl: logos["ionic"], subText: "" },
  { imgUrl: logos["americanBTC"], subText: "" },
  { imgUrl: logos["align"], subText: "" },
  { imgUrl: logos["pioneerLabs"], subText: "" },
  { imgUrl: logos["salt"], subText: "" },
  { imgUrl: logos["solari"], subText: "" },
  { imgUrl: logos["renegade"], subText: "" },
  { imgUrl: logos["khosla"], subText: "" },
];
